import {Injectable} from "@angular/core";
import {Observable} from "rxjs/Observable";
import {ObservableBackendService} from "./observableBackend.service";
import {Vehicle} from "../domain/vehicle";
import {Contract} from "../domain/contract";
import {Page} from "../domain/page";
import {URLSearchParams, Response} from "@angular/http";

@Injectable()
export class ContractsService {

    constructor(private backendService:ObservableBackendService) {
    }

    public downloadFilterContracts(filter:Vehicle, page:number, itemsPerPage:number):Observable<Response> {
        return this.backendService.getAttachment("contractsReport", ContractsService.setParams(filter, page, itemsPerPage));
    }

    public static getURLFilterContracts(filter:Vehicle, page:number, itemsPerPage:number):string {
        return "/contractsReport?" + ContractsService.setParams(filter, page, itemsPerPage).toString();
    }

    public static getURLContractBulkload(documentId:string):string {
        return "/contractsBulkloadDocument/" + documentId;
    }

    public downloadFilterContractsForIE(filter:Vehicle, page:number, itemsPerPage:number):string {
        return window.location.origin + '/contractsReport?' + ContractsService.setParams(filter, page, itemsPerPage).toString();
    }

    private static setParams(filter:Vehicle, page:number, itemsPerPage:number):URLSearchParams {
        let params = new URLSearchParams();
        if (filter.patent) {
            params.set('patent', filter.patent);
        }
        if (filter.contract.bank && filter.contract.bank.id) {
            params.set('contract.bank.id', filter.contract.bank.id);
        }
        if (filter.contract.contractNumber) {
            params.set('contract.contractNumber', filter.contract.contractNumber);
        }
        if (filter.contract.cuit) {
            params.set('contract.cuit', filter.contract.cuit);
        }
        params.set('length', String(itemsPerPage));
        params.set('pageNumber', String(page));
        return params;
    }

    public findContracts(filter:Vehicle, page:number, itemsPerPage:number):Observable<Page> {
        let params = new URLSearchParams();
        if (filter.patent) {
            params.set('patent', filter.patent);
        }
        if (filter.contract.bank && filter.contract.bank.id) {
            params.set('contract.bank.id', filter.contract.bank.id);
        }
        if (filter.contract.contractNumber) {
            params.set('contract.contractNumber', filter.contract.contractNumber);
        }
        if (filter.contract.cuit) {
            params.set('contract.cuit', filter.contract.cuit);
        }
        params.set('length', String(itemsPerPage));
        params.set('pageNumber', String(page));
        return this.backendService.get("contracts", params);
    }

    public save(contract:Contract):Observable<Contract> {
        if (contract.id != null) {
            return this.backendService.post("contract", contract, null);
        } else {
            return this.backendService.put("contract", contract, null);
        }
    }

    public delete(contractId:string):Observable<Contract> {
        return this.backendService.delete("contract/" + contractId, null, null);
    }

    public getContract(contractId:string):Observable<Contract> {
        return this.backendService.get("contract/" + contractId, null);
    }

    public getVehicles(contractId:string, page?:number, itemsPerPage?:number) {
        let params = new URLSearchParams();
        if (page && itemsPerPage) {
            params.set('length', String(itemsPerPage));
            params.set('pageNumber', String(page));
            return this.backendService.get("contract/" + contractId + "/vehiclesPage", params);
        }
        return this.backendService.get("contract/" + contractId + "/vehicles", params);
    }

    public getContractByContractNumberAndBank(contractNumber:string, bankId:string):Observable<Contract> {
        return this.backendService.get("contract/" + bankId + "/" + contractNumber, null);
    }

    public getContractByContractNumber(contractNumber: string) :Observable<Contract> {
        return this.backendService.get("contract/" + contractNumber, null);
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/service/contracts.service.ts
 **/